export default "__VITE_ASSET__nG3R5NG8__"